import React, {Component} from 'react';
import { Card, List } from 'semantic-ui-react';

export default class RequirementsContent extends Component {
    render() {
        const {requirements} = this.props;

        if(!requirements) {
            return null;
        }

        const level = requirements.Level ?
                    <List.Item>{`Requires level ${requirements.Level}`}</List.Item> :
                    null;

        const callings = requirements.Callings ?
                    <List.Item>{`Callings: ${requirements.Callings.join(', ')}`}</List.Item> :
                    null;

        const reputation = requirements.Faction ?
                    <List.Item>{requirements.Faction.Name}: {this.getFactionLevelName(requirements.Faction.Level)}</List.Item> :
                    null;
        return (
            <Card.Content>
                <List>
                    {level}
                    {callings}
                    {reputation}
                </List>
            </Card.Content>
        )
    }

    getFactionLevelName(level) {
        switch(level) {
            case '0':
                return 'Neutral';
            case '1':
                return 'Friendly';
            case '2':
                return 'Decorated';
            case '3':
                return 'Honored';
            case '4':
                return 'Revered';
            case '5':
                return 'Glorified';
            case '6':
                return 'Venerated';
            default:
                return 'Unspecified';
        }
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/RequirementsContent.jsx